import React, { useContext, useEffect, useState } from "react";

import checkoutSteps from "../../../../../providers/GasCheckoutSteps";
import { DataContext } from "../../../../../providers/GasDataProvider";
import CalculatorProductDetails from "../../../../shared/CalculatorProductDetails";
import CalculatorProducts from "../../../../shared/CalculatorProducts";
import { navigate } from "../../../../shared/LinkComponent";
import LoadingIndicator from "../../../../shared/LoadingIndicator";
import GasMessage from "../GasMessage";
import GasProduct from "./GasProduct";

const GasCalculatorResult = () => {
    const dataContext = useContext(DataContext);
    const {
        zipcode,
        consumption,
        result,
        loading,
        zipcodeIsValid,
        consumptionIsValid,
        productChoice,
    } = dataContext.data;
    const { setProductChoice, calculateStreet } = dataContext.actions;
    const [expanded, setExpanded] = useState([]);

    const isExpanded = (itemIndex) => {
        return expanded.includes(itemIndex);
    };

    const toggleExpand = (itemIndex) => {
        if (isExpanded(itemIndex)) {
            setExpanded(expanded.filter((item) => item !== itemIndex));
        } else {
            setExpanded([...expanded, itemIndex]);
        }
    };

    useEffect(() => {
        if (!result && zipcodeIsValid && consumptionIsValid) {
            calculateStreet(zipcode, consumption);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [result]);

    return (
        <div>
            {loading && (
                <LoadingIndicator>Preise werden ermittelt</LoadingIndicator>
            )}
            {!loading && zipcodeIsValid && consumptionIsValid && result && (
                <React.Fragment>
                    <GasMessage />

                    <CalculatorProducts
                        products={result.products}
                        activeIndex={productChoice}
                        onIndexChange={setProductChoice}
                        showTotalPriceLabel
                    />

                    <CalculatorProductDetails activeIndex={productChoice}>
                        {result.products.map((product, idx) => (
                            <GasProduct
                                key={idx}
                                product={product}
                                consumption={consumption}
                                expanded={isExpanded(idx)}
                                onExpand={() => toggleExpand(idx)}
                                onSubmit={() => {
                                    setProductChoice(idx);
                                    let url = checkoutSteps[0].url;
                                    setTimeout(() => {
                                        navigate("/gas/bestellung/" + url);
                                    }, 0);
                                }}
                            />
                        ))}
                    </CalculatorProductDetails>
                </React.Fragment>
            )}
        </div>
    );
};

export default GasCalculatorResult;
